.highlight{font-weight:700}
/*# sourceMappingURL=highlight.component-AOQCWOKG.css.map */
